<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import DataSettings from './DataSettings.vue';
import LanguageSettings from './LanguageSettings.vue';

//#region Globals
const { t } = useI18n();
//#endregion

//#region Props & Emits
const emits = defineEmits(['onCloseSettings']);
//#endregion

const dataSettings = ref<InstanceType<typeof DataSettings>>();
</script>

<template>
   <NxtSideModal :title="t('settings.settings', 2)" class="settings" :width="'60vw'" @on-close="emits('onCloseSettings')">
      <div class="settings-panel">
         <LanguageSettings @reload="dataSettings?.reset(true)" />
         <DataSettings ref="dataSettings" />
      </div>
   </NxtSideModal>
</template>

<style lang="scss" scoped>
.settings-panel {
   display: flex;
   flex-direction: column;
   gap: var(--nxt-gutter);
   padding-top: var(--nxt-gutter);
}
</style>
